import React, { Component } from "react";
import "./CommissionReportSupervisor.css";
import { connect } from "react-redux";
import {
    formatedDateTimeToUSA,
    getDateTimeCurrentBrowserAtMidnight,
} from "../../auxiliary/generalFunctions";
import {
    APPLICATION_NAME
} from "../../core/constants";

import Header from "../../components/CRM/Header";
import ButtonIcon from "../../components/general/ButtonIcon";

import TableEditCommissionReportSupervisor from "../../components/general/TableEditCommissionReportSupervisor";
import InputGeneral from "../../components/general/InputGeneral";
import { withRouter } from "react-router-dom";
import CommissionReportProspectionController from "../../controllers/CommissionReportProspectionController";

const commissionReportProspectionController = new CommissionReportProspectionController();

const initialState = {
    allCommissionReportSupervisor: [],
    currentMonthYear: "", //looks like: "2022-04"
}

class CommissionReportSupervisor extends Component
{
    state = { ...initialState }

    componentDidMount = async () =>
    {
        document.title = `${APPLICATION_NAME} - Relatório de Comissão - Supervisores`;

        let { params } = this.props.match;
        let currentDate = formatedDateTimeToUSA(getDateTimeCurrentBrowserAtMidnight()); //looks like "2022-04-01"

        if (params?.interval && params.interval !== undefined)
        {
            currentDate = params.interval; //looks like "2022-04"
        }

        await this.setCurrentMonthYear(currentDate);
        await this.getCommissionReportSupervisor();
    }

    componentDidUpdate = async (prevProps, prevState) =>
    {
        // console.log("COMMISSION REPORT prevProps ", prevProps);
        // console.log("COMMISSION REPORT this.props ", this.props);

        if (prevProps.hasPermissionsLoaded !== this.props.hasPermissionsLoaded) 
		{
			if (!this.props.permissions.toView) { this.props.history.push(`/activities`); }
		}
    }

    setCurrentMonthYear = async (currentDate) =>
	{
		let parts = currentDate.toString().split("-");

		let y = parseInt(parts[0]);
		let m = parseInt(parts[1]).toString().padStart(2, '0');

		let currentMonthYear = `${y}-${m}`;

		await this.setState({currentMonthYear});
	}

    getCommissionReportSupervisor = async () =>
    {
        const result = await commissionReportProspectionController.get(
            this.state.currentMonthYear,
            "SUPERVISOR"
        );

        if (!result.status) 
        {
            return;
        }

        let allCommissionReportSupervisor = [];

        for (const report of result.data.data)
        {
            allCommissionReportSupervisor.push({
                id: report.CMP_ID,
                name: report.PER_NAME,
                amountBusiness: report.CMP_AMOUNT_BUSINESS,
                amountScheduledSamePeriod: report.CMP_AMOUNT_BUSINESS_SCHEDULED_SAME_PERIOD,
                amountScheduledAnotherPeriod: report.CMP_AMOUNT_BUSINESS_SCHEDULED_ANOTHER_PERIOD,
                amountScheduledTo: report.CMP_AMOUNT_BUSINESS_SCHEDULED_TO,
                amountShowedup: report.CMP_AMOUNT_BUSINESS_SHOWEDUP,
                percentScheduled: report.CMP_PERCENT_BUSINESS_SCHEDULED,
                percentShowedup: report.CMP_PERCENT_BUSINESS_SHOWEDUP,
                amountCommissionUnitary: report.CMP_AMOUNT_COMMISSION_UNITARY,
                amountCommissionTotal: report.CMP_AMOUNT_COMMISSION_TOTAL,
            });
        }

        await this.setState({ allCommissionReportSupervisor });
    }

    render ()
    {
        return (
            <div className="commissionReportSupervisor">
                <Header title="Relatório de Comissão - Supervisores" classaditional="headerCommissionReportSupervisor" />
                <div className="warningCommissionReportSupervisor d-flex d-lg-none">
                    <span>Opsssss, alguns recursos foram desativados para dispositivos móveis.</span>
                </div>
                <div className="containerNavigationHeaderCommissionReportSupervisor">
                    <ButtonIcon
                        icon="far fa-bars"
                        classaditional="buttonNavigationHeaderCommissionReportSupervisor active"
                        onClick={() => {}}
                    />
                    <div className={`filterStatusHeaderCommissionRules d-none d-lg-flex ml-auto`}>
                        <InputGeneral
                            classaditional="inputFilterCommissionRules"
                            type="month"
                            value={this.state.currentMonthYear}
                            onChange={async (e) => {
                                await this.setCurrentMonthYear(e.target.value);
                                await this.getCommissionReportSupervisor();
                            }}
                        />
                    </div>
                </div>
                <div className="containerListHeaderCommissionReportSupervisor">
                    <TableEditCommissionReportSupervisor
                        data={this.state.allCommissionReportSupervisor}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps (state)
{
    const { user } = state.auth;
    const permissions = state.permissions.commissionReportSupervisor;
    const hasPermissionsLoaded = state.permissions.hasPermissionsLoaded;
    
    return {
        hasPermissionsLoaded,
        user,
        permissions
    }
}

export default withRouter(connect(mapStateToProps, null)(CommissionReportSupervisor));